export default __webpack_public_path__ + "static/media/on-time-and-late.78ba7fd6.svg";